import React from "react";
import { HelpCircle } from "lucide-react";
import { Link } from "react-router-dom";

import { cn } from "src/utils/cn";
import { useSidebar } from "src/contexts/SidebarContext";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "src/components/ui/tooltip";
import { NotificationBell } from "src/features/notifications/components/NotificationBell";

export function SidebarFooter() {
  const { collapsed } = useSidebar();

  return (
    <div className={cn("flex items-center gap-1", collapsed ? "flex-col" : "flex-row px-1")}>
      {/* Notification Bell */}
      <div className={collapsed ? "flex w-10 justify-center" : ""}>
        <NotificationBell />
      </div>

      {/* Help link */}
      <Tooltip>
        <TooltipTrigger asChild>
          <Link
            to="/help"
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-lg text-slate-500 transition-colors hover:bg-white/80 hover:text-slate-700",
            )}
          >
            <HelpCircle className="h-4 w-4 shrink-0" />
          </Link>
        </TooltipTrigger>
        <TooltipContent side={collapsed ? "right" : "top"}>Help</TooltipContent>
      </Tooltip>
    </div>
  );
}

